import { render } from "./BrowserViewerList.vue?vue&type=template&id=7bbfa3e4"
import script from "./BrowserViewerList.vue?vue&type=script&lang=js"
export * from "./BrowserViewerList.vue?vue&type=script&lang=js"

import "./BrowserViewerList.vue?vue&type=style&index=0&id=7bbfa3e4&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__